import { render } from "./Sizes.vue?vue&type=template&id=2d2f2948"
import script from "./Sizes.vue?vue&type=script&lang=js"
export * from "./Sizes.vue?vue&type=script&lang=js"

import "./Sizes.vue?vue&type=style&index=0&id=2d2f2948&lang=css"

import exportComponent from "/home/los7/Documents/Sites/IntendedMe/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__